export default "__VITE_ASSET__C7ff9Lmw__"